module.exports = __webpack_public_path__ + "img/logo-ingeray1.17461af4.svg";